var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.calcHits(),"item-key":"_id","dense":"","fixed-header":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }